import React, { createContext } from 'react';
import { useLocalObservable } from 'mobx-react-lite';
import uploadStore from './uploadStore';

type UploadStoreType = ReturnType<typeof uploadStore>;

export const uploadContext = createContext<UploadStoreType>(null!);

const UploadProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const store = useLocalObservable(uploadStore);
    return (
        <uploadContext.Provider value={store}>
            {children}
        </uploadContext.Provider>
    );
};

export default UploadProvider;
